<script>
import * as m from '@app/paraglide/messages.js';
  /** @type {{errorMsg?: string}} */
  let { errorMsg = "" } = $props();
</script>
{#if errorMsg}
<button
  id="errorMsgBtn"
  type="button"
  class="btn btn-link text-custom-medium"
  aria-label={m.event_realtime_errors_aria_label()}
  aria-live="polite"
  title={errorMsg}>
    <i class="bi bi-exclamation-diamond-fill text-danger"></i>
</button>
{/if}

<style lang="css">
    button {
        padding : 2px;
        margin : 0;
    }
</style>